export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark'
}

export const LANGUAGES = {
  ES: 'es',
  EN: 'en'
}

export const STORAGE_KEYS = {
  THEME: 'theme',
  LANGUAGE: 'language'
}